import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Theme from "../../assets/Theme";
//import config from "../../store/config/config.json";
import Header from "../../components/Header";
import SearchTrainsTickets from "../../forms/SearchTrainsTickets";
import Footer from "../../components/Footer";
import ModalTravelInformation from "../ResultsPage/partials/ModalTravelInformation";
//import ContainerSegment from './partials/ContainerSegment';
import SegmentsFilter from "./partials/SegmentFilter";
import DetailRate from "./partials/DetailRate";
import ResumeSearch from "../../components/ResumeSearch";
import SegmentTitle from "./partials/SegmentTitle";
import { AppBar, Tabs, Tab } from "@material-ui/core";
import {
  Container,
  Grid,
  Collapse,
  Button,
  Typography,
  Hidden,
  Icon,
  IconButton,
} from "@material-ui/core";
// import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import { addAction, getSearchAction, saveFirstSearchData } from "../../store/actions/index";
import NumberFormat from "react-number-format";
//import Image from '../../components/Image';
import Preload from "../../components/Preload";
import { Redirect } from "react-router-dom";

class ResultPage extends Component {
  constructor(props) {
    super(props);
    sessionStorage.removeItem("typeProduct");
    sessionStorage.setItem("typeProduct", "tickets");
    this.tokenClient = this.props.match.params.token;
    this.config = require(`../../store/config/${this.tokenClient}/config.json`);
    this.state = {
      filterText: "DELETE_FILTER",
      itemsCart: this.props.itemsCart,
      pricesItem: this.props.pricesItem,
      totalPrice: this.props.totalPrice,
      segmentState: this.props.segmentState,
      idPrice: this.props.idPrice,
      indiceSegment: 0,
      legs: this.props.location.state,
      directOnly: this.props.directOnly,
      hasDirectTrains: false,
      ages: props.match.params.ages.split('-'),
      activeTab: 0
    };
    this.nodePrice = this.config.pricing.search;
    this.handleFilterTextChange = this.handleFilterTextChange.bind(this);
    this.handleDirectOnlyChange = this.handleDirectOnlyChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.preload && !this.props.preload) {
      // Si previamente preload era true y ahora es false cambiar el estado de directOnly
      this.setState({ directOnly: this.props.directOnly });
    }
  }

  selectTrain = (offersId, trainId, idPriceOffer, indexSegment, dictionary) => {
    this.setState((prevState) => {
      let dicProd = [];
      let total = 0;
      let totalPrice = [prevState.totalPrice];
      let idPrice = [...prevState.idPrice];
      const pricesItem = [...prevState.pricesItem];
      const segmentState = [...prevState.segmentState];
      const itemsCart = [...prevState.itemsCart];
      const ages = prevState.ages

      pricesItem[indexSegment] = {
        price: parseInt(
          Math.sign(trainId.prices.api.values[this.nodePrice]) *
          Math.floor(
            Math.abs(trainId.prices.api.values[this.nodePrice]) + 0.5
          )
        ),
      }; //{ price: trainId.prices.api.PRECIO_NETO }
      idPrice[indexSegment] = { idPriceOffer };

      pricesItem.forEach(function (pr) {
        total += parseInt(
          Math.sign(pr.price) * Math.floor(Math.abs(pr.price) + 0.5)
        );
      });

      trainId.fareOffers.map((fares, x) =>
        fares.fares.map((productCode, y) =>
          dicProd.push(dictionary.products[productCode.productCode])
        )
      );

      itemsCart[indexSegment] = {
        offersId: offersId,
        trainId: trainId,
        dicProd,
      };
      segmentState[indexSegment] = true;

      this.props.dispatchAddAction(
        itemsCart,
        total,
        idPrice,
        pricesItem,
        segmentState
      );

      return {
        itemsCart: itemsCart,
        pricesItem: pricesItem,
        totalPrice: parseInt(total),
        segmentState: segmentState,
        idPrice: idPrice,
        ages: ages
      };
    });
  };

  handleFilterTextChange(filterText) {
    this.setState({ filterText: filterText });
  }

  handleDirectOnlyChange(directOnly) {
    this.setState({ directOnly: directOnly });
  }

  resetDirectOnly = (directOnly) => {
    this.setState({ directOnly: false });
  };

  getDuplicatedOffers(highlight, type) {
    let mainArray = [];

    for (let i = 0; i < highlight.length; i++) {
      let subArray = [];
      for (let j = 0; j < highlight.length; j++) {
        subArray.push(highlight[i].highlights[j].offers);
      }
      mainArray.push(subArray);
    }

    let array1 = mainArray[0][0];
    let array2 = mainArray[1][0];

    let array3 = mainArray[0][1];
    let array4 = mainArray[1][1];

    for (let i = 0; i < array1.length; i++) {
      for (let j = 0; j < array2.length; j++) {
        if (array1[i] === array2[j] && type === "MOST_FLEXIBLE") {
          return false;
        }
      }
    }
    for (let i = 0; i < array3.length; i++) {
      for (let j = 0; j < array4.length; j++) {
        if (array3[i] === array4[j] && type === "MOST_FLEXIBLE") {
          return false;
        }
      }
    }
    return true;
  }

  handleTimeChange = (e) => {
    const { origin,
      destination,
      departure,
      time,
      ages,
      tramos, tokenClient, apiToken } = this.props.firstSearchData

    const currentTimeArray = this.props.firstSearchData.time;
    let newTime = currentTimeArray[this.state.activeTab]

    if (e === 'previous') {
      const hour = parseInt(newTime.slice(0, 2));
      const minutes = parseInt(newTime.slice(2));
      const newTimeNumber = hour * 100 + minutes;

      if (newTimeNumber >= 300) {
        newTime = moment(newTime, 'HHmm').subtract(4, 'hours').format('HHmm');
      }
    } else if (e === 'next') {
      const hour = parseInt(newTime.slice(0, 2));
      const minutes = parseInt(newTime.slice(2));
      const newTimeNumber = hour * 100 + minutes;

      if (newTimeNumber <= 1800) {
        newTime = moment(newTime, 'HHmm').add(4, 'hours').format('HHmm');
      }
    } else {
      return newTime
    }


    currentTimeArray[this.state.activeTab] = newTime

    this.props.dispatchGetSearch(
      origin,
      destination,
      departure,
      currentTimeArray,
      ages,
      tramos,
      tokenClient,
      apiToken,
      this.state.directOnly
    );

    this.props.dispatchSaveFirstSearchData(origin,
      destination,
      departure,
      currentTimeArray,
      ages,
      tramos,
      this.tokenClient,
      apiToken,
      this.state.directOnly);


    // this.props.saveResultsList(listaDeResultados);
  };

  handleTabClick = (index) => {
    this.setState({ activeTab: index });
  };

  render() {
    let config = this.config;
    var preloadResult = sessionStorage.getItem("preloadResult");

    const SearchContainer = (props) => {
      const [expanded, setExpanded] = React.useState(false);
      const handleExpandClick = () => { setExpanded(!expanded) };

      return (
        <div className={`result_search_container`}>
          <div className="form-inverse">
            <div className="page-maxwidth resume-mobile">
              <Container maxWidth="xl">
                <ResumeSearch
                  searchData={this.props?.results?.segments}
                  handleExpandClick={handleExpandClick}
                  expanded={expanded}
                />
              </Container>
            </div>
          </div>
          <Collapse in={expanded} timeout="auto" unmountOnExit>
            <div className="result_search_form">
              <div className="page-maxwidth">
                <Container maxWidth="xl">
                  <SearchTrainsTickets
                    legsPrueba={this.state.legs}
                    searchData={this.props?.results ? true : false}
                    apiToken={config.credential.api.token}
                    apiUrl={config.credential.api.url}
                    ref={this.searchTrainsRef}
                  />
                </Container>
              </div>
            </div>
          </Collapse>
        </div>
      );
    };

    const HeaderRow = (props) => {
      const leg = props.leg;
      const id = props.id;
      return (
        <div className="tramo-header">
          <Grid container spacing={1}>
            <Grid item md={12}>
              <Typography variant="h2" className="title">
                <span className="tramo-nro">{id + 1}</span>{" "}
                <strong>Elige una opción </strong> para el tramo{" "}
                <strong>
                  {leg.origin.localLabel} - {leg.destination.localLabel}
                </strong>
              </Typography>
            </Grid>
            {/*  <Hidden smDown>
                            <Grid item xs={4} className="text-right">
                                <Button className="btn-tramos" size="small" variant="outlined" color="secondary">Tramo anterior</Button>
                                <Button className="btn-tramos" size="small" variant="outlined" color="secondary">Siguiente tramo</Button>
                            </Grid>
                        </Hidden> */}
          </Grid>
        </div>
      );
    };

    const HorariosRow = (props) => {
      const departure = moment(props.horarios.departure).format("H:mm a");
      const arrival = moment(props.horarios.arrival).format("H:mm a");
      const duration = props.legSolutionData.duration;
      const vehicle = props.legSolutionData.segments[0].vehicle;

      return (
        <div className="content-horarios">
          <div className="content">
            <Grid container spacing={0}>
              <Grid item xs={9}>
                <div className="hora">
                  <span>{departure}</span> <Icon>arrow_forward</Icon>{" "}
                  <span>{arrival}</span>
                </div>
              </Grid>
              <Grid item xs={3}>
                <div className="duracion text-right">{duration}</div>
              </Grid>
            </Grid>
            <Grid container spacing={0}>
              <Grid item xs={9}>
                <div className="tren">
                  <Grid container spacing={1}>
                    {/*   <Grid item xs={4}>
                                            <div className="img-rentadora">
                                                <Image img={`thumb_default.png`} alt={'tren'} />
                                            </div>
                                        </Grid> */}
                    <Grid item xs={12}>
                      <div className="nro-tren">
                        Tren {vehicle.code} N°: {vehicle.reference}
                      </div>
                      <div className="nombre-tren">{vehicle.type}</div>
                      <div className="nombre-tren">
                        {props.legSolutionData.segments[0].operatingCarrier}
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Grid>
              <Grid item xs={3} className="text-right">
                <ModalTravelInformation
                  type="escala"
                  origin={props.horarios.origin.localLabel}
                  destination={props.horarios.destination.localLabel}
                  departure={moment(props.horarios.departure)
                    .locale("es")
                    .format("dddd, Do MMM YY")}
                  segments={props.legSolutionData.segments}
                />
              </Grid>
            </Grid>
          </div>
        </div>
      );
    };

    const TarifasRate = (props) => {
      const arrOffers = props.dictionary.offers;
      const dictionary = props.dictionary;
      const idOffers = props.idOffers;
      const legSolutionData = props.legSolutionData;
      const indexSegment = props.indexSegment;
      const filter = props.filter;
      const strategy = props.strategy;
      const selected = true;
      return (
        <div className="TarifasRate">
          <div className="content">
            <Grid container spacing={1}>
              {idOffers
                .filter((offers) => offers.comfort)
                .map((allOffersComfort, idxOfferOffersComfort) => {
                  return (
                    <Grid key={idxOfferOffersComfort} item xs={4}>
                      <Grid container spacing={1}>
                        {allOffersComfort.offers.map((id, i) => (
                          <Fragment key={i}>
                            <Grid item xs={6}>
                              <Button
                                size="small"
                                className={`offerButton 
																	${allOffersComfort.comfort} 
																	${filter === "BEST_PRICE" && "cheaper"} 
																	${filter === "MOST_FLEXIBLE" && "more-flexible"}
																	${this.props.idPrice[indexSegment]
                                    ?.idPriceOffer === id.concat(strategy) &&
                                  "selected"
                                  }`}
                                variant="contained"
                                color="default"
                                index="0"
                                onClick={() =>
                                  this.selectTrain(
                                    legSolutionData.segments,
                                    arrOffers[id],
                                    id.concat(strategy),
                                    indexSegment,
                                    dictionary
                                  )
                                }
                              >
                                {" "}
                                {/*  {this.props.idPrice[indexSegment]?.idPriceOffer === id.concat(strategy)?'true':'false'} */}
                                <NumberFormat
                                  value={parseInt(
                                    Math.sign(
                                      arrOffers[id]?.prices.api.values[
                                      this.nodePrice
                                      ]
                                    ) *
                                    Math.floor(
                                      Math.abs(
                                        arrOffers[id]?.prices.api.values[
                                        this.nodePrice
                                        ]
                                      ) + 0.5
                                    )
                                  )}
                                  displayType={"text"}
                                  thousandSeparator={true}
                                  prefix={config.credential.currency.concat(
                                    " "
                                  )}
                                  renderText={(value) => <span> {value}</span>}
                                  decimalScale="2"
                                />
                              </Button>

                              {/* <Button size="small" className={`offerButton selected`}
                                        variant="contained" color="default" >USD 00.00</Button> */}
                            </Grid>
                          </Fragment>
                        ))}{" "}
                      </Grid>
                    </Grid>
                  );
                })}
            </Grid>
          </div>
        </div>
      );
    };

    const SegmentInfo = (props) => {
      const {
        segment,
        indexSegment,
        /* segments,  */ filterText,
        onFilterTextChange /* , x,  */,
      } = props;

      const hasDirectTrains = segment.highlights?.reduce(
        (hasDirect, highlightItem) => {
          // Verificar si alguno de los elementos tiene longitud igual a 1
          const hasLengthOne =
            segment.dictionary.legsSolutions[
              highlightItem[0].legSolutionData.id
            ].segments.length === 1;

          // Si ya se encontró un tren directo previamente, no es necesario seguir evaluando los siguientes highlights
          if (hasDirect) {
            return true;
          }

          return hasLengthOne;
        },
        false
      );

      return (
        <div className="segmentRateCategoryRow content-results">
          <div className="white-content">
            <HeaderRow
              leg={segment.dictionary.leg}
              key={indexSegment}
              id={indexSegment}
            />
            <div className="content-results-table">
              <Hidden smDown>
                <div className="row_segment_header row-labels text-center">
                  <Grid container>
                    <Grid item xs={4}>
                      <div className="navigation-horarios">
                        <IconButton
                          aria-label="preview"
                          className="button-prev"
                          onClick={(e) => this.handleTimeChange('previous')}

                        >
                          <Icon>arrow_back</Icon>
                        </IconButton>
                        <div className="label-horarios">Horarios</div>
                        <IconButton
                          aria-label="preview"
                          className="button-next"
                          onClick={(e) => this.handleTimeChange('next')}
                        >
                          <Icon>arrow_forward</Icon>
                        </IconButton>
                      </div>
                    </Grid>
                    <Grid item xs={8}>
                      <div className="row-labels">
                        <Grid container>
                          <Grid item xs>
                            <div className="label-rates">Standard</div>
                          </Grid>
                          <Grid item xs>
                            <div className="label-rates">Comfort</div>
                          </Grid>
                          <Grid item xs>
                            <div className="label-rates">Premier</div>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                  </Grid>
                </div>
              </Hidden>

              {/* Renderiza el mensaje solamente si el check de trenes directos está marcado y si no hay trenes directos para el tramo */}
              {this.state.directOnly && !hasDirectTrains && (
                <div
                  className="no-direct-trains-message"
                  style={{
                    margin: "50px 0",
                    textAlign: "center",
                    fontSize: "24px",
                  }}
                >
                  No se encontraron trenes directos para este tramo
                </div>
              )}

              {segment.highlights?.map((highlight, idxHighlight) => {
                return (
                  <Fragment key={idxHighlight}>
                    {this.state.directOnly ? (
                      hasDirectTrains &&
                        segment.dictionary.legsSolutions[
                          highlight[0].legSolutionData.id
                        ].segments.length === 1 ? (
                        <div className={`row_segment row-horarios-tarifas`}>
                          <Grid container>
                            <Grid item md={4}>
                              <HorariosRow
                                horarios={highlight[0].legSolutionData}
                                legSolutionData={
                                  segment.dictionary.legsSolutions[
                                  highlight[0].legSolutionData.id
                                  ]
                                }
                              />
                            </Grid>
                            <Grid item md={8}>
                              <Fragment>
                                {highlight.map((legSolutionData, x) => {
                                  const tarifasrate = (
                                    <TarifasRate
                                      key={x}
                                      strategy={highlight[x].strategy}
                                      addAction={this.props.addAction}
                                      indexSegment={indexSegment}
                                      dictionary={segment.dictionary}
                                      idOffers={legSolutionData.highlights}
                                      filter={legSolutionData.strategy}
                                      legSolutionData={
                                        segment.dictionary.legsSolutions[
                                        highlight[0].legSolutionData.id
                                        ]
                                      }
                                    />
                                  );
                                  return (
                                    <Fragment key={x}>
                                      {legSolutionData.strategy.indexOf(
                                        filterText
                                      ) === 0
                                        ? tarifasrate
                                        : filterText === "DELETE_FILTER" &&
                                        this.getDuplicatedOffers(
                                          highlight,
                                          highlight[x].strategy
                                        ) &&
                                        tarifasrate}
                                    </Fragment>
                                  );
                                })}
                              </Fragment>
                            </Grid>
                          </Grid>
                        </div>
                      ) : !hasDirectTrains ? (
                        <>
                          <div className={`row_segment row-horarios-tarifas`}>
                            <Grid container>
                              <Grid item md={4}>
                                <HorariosRow
                                  horarios={highlight[0].legSolutionData}
                                  legSolutionData={
                                    segment.dictionary.legsSolutions[
                                    highlight[0].legSolutionData.id
                                    ]
                                  }
                                />
                              </Grid>
                              <Grid item md={8}>
                                <Fragment>
                                  {highlight.map((legSolutionData, x) => {
                                    const tarifasrate = (
                                      <TarifasRate
                                        key={x}
                                        strategy={highlight[x].strategy}
                                        addAction={this.props.addAction}
                                        indexSegment={indexSegment}
                                        dictionary={segment.dictionary}
                                        idOffers={legSolutionData.highlights}
                                        filter={legSolutionData.strategy}
                                        legSolutionData={
                                          segment.dictionary.legsSolutions[
                                          highlight[0].legSolutionData.id
                                          ]
                                        }
                                      />
                                    );
                                    return (
                                      <Fragment key={x}>
                                        {legSolutionData.strategy.indexOf(
                                          filterText
                                        ) === 0
                                          ? tarifasrate
                                          : filterText === "DELETE_FILTER" &&
                                          this.getDuplicatedOffers(
                                            highlight,
                                            highlight[x].strategy
                                          ) &&
                                          tarifasrate}
                                      </Fragment>
                                    );
                                  })}
                                </Fragment>
                              </Grid>
                            </Grid>
                          </div>
                        </>
                      ) : null
                    ) : (
                      <div className={`row_segment row-horarios-tarifas`}>
                        <Grid container>
                          <Grid item md={4}>
                            <HorariosRow
                              horarios={highlight[0].legSolutionData}
                              legSolutionData={
                                segment.dictionary.legsSolutions[
                                highlight[0].legSolutionData.id
                                ]
                              }
                            />
                          </Grid>
                          <Grid item md={8}>
                            <Fragment>
                              {highlight.map((legSolutionData, x) => {
                                const tarifasrate = (
                                  <TarifasRate
                                    key={x}
                                    strategy={highlight[x].strategy}
                                    addAction={this.props.addAction}
                                    indexSegment={indexSegment}
                                    dictionary={segment.dictionary}
                                    idOffers={legSolutionData.highlights}
                                    filter={legSolutionData.strategy}
                                    legSolutionData={
                                      segment.dictionary.legsSolutions[
                                      highlight[0].legSolutionData.id
                                      ]
                                    }
                                  />
                                );
                                return (
                                  <Fragment key={x}>
                                    {legSolutionData.strategy.indexOf(
                                      filterText
                                    ) === 0
                                      ? tarifasrate
                                      : filterText === "DELETE_FILTER" &&
                                      this.getDuplicatedOffers(
                                        highlight,
                                        highlight[x].strategy
                                      ) &&
                                      tarifasrate}
                                  </Fragment>
                                );
                              })}
                            </Fragment>
                          </Grid>
                        </Grid>
                      </div>
                    )}
                  </Fragment>
                );
              })}
            </div>
          </div>
        </div>
      );
    };

    const ContainerSegment = ({ segments, filterText, onFilterTextChange }) => {
      function TabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
          <div
            className="nav-tabs"
            role="tabpanel"
            hidden={value !== index}
            id={`result-tabpanel-${index}`}
            aria-labelledby={`result-tab-${index}`}
            {...other}
          >
            {value === index && <div>{children}</div>}
          </div>
        );
      }

      function a11yProps(index) {
        return {
          id: `result-tab-${index}`,
          "aria-controls": `result-tabpanel-${index}`,
        };
      }

      //const [value, setValue] = React.useState(0);

      const handleChange = (event, newValue) =>
        this.setState({ indiceSegment: newValue });

      return (
        <div className={`ContainerSegment`}>
          <AppBar position="static" color="default">
            <Tabs
              className="tabSegmentTitle"
              /* variant="fullWidth" */ value={this.state.indiceSegment}
              onChange={handleChange}
              indicatorColor="secondary"
              textColor="secondary"
              variant="scrollable"
              scrollButtons="auto"
              aria-label="Tabs Segmentos"

            >
              {segments.map((segment, i) =>
                segment.highlights ? (
                  <Tab
                    className="tab-custom"
                    selected={true}
                    key={i}
                    onClick={() => this.handleTabClick(i)}
                    label={
                      <SegmentTitle
                        index={i}
                        segmentsLength={segments.length}
                        segment={segment}
                        selectedidPrice={this.props.idPrice[i] ? true : false}
                      />
                    }
                    {...a11yProps(i)}
                  />
                ) : (
                  <Tab
                    disabled={true}
                    disableRipple={true}
                    className="tab-custom"
                    selected={false}
                    key={i}
                    label={
                      <SegmentTitle
                        index={i}
                        segmentsLength={segments.length}
                        segment={segment}
                        selectedidPrice={this.props.idPrice[i] ? true : false}
                      />
                    }
                    {...a11yProps(i)}
                  />
                )
              )}
            </Tabs>
          </AppBar>
          {segments.map((segment, x) => (
            <TabPanel
              className="tabSegmentPanel"
              value={this.state.indiceSegment}
              index={x}
              key={x}
            >
              <SegmentInfo
                indexSegment={x}
                segment={segment}
                segments={segments}
                filterText={filterText}
                onFilterTextChange={onFilterTextChange}
              />
            </TabPanel>
          ))}
        </div>
      );
    };

    const MainContent = () => {
      return (
        <main className={`main_content`}>
          <div className="page-maxwidth">
            <Container maxWidth="xl">
              <Grid container spacing={1}>
                <Hidden mdUp>
                  <Grid item xs={12}>
                    <DetailRate
                      x_correlation_id={this.props.results.x_correlation_id}
                      itemsCart={this.props.itemsCart}
                      totalPrice={this.props.totalPrice}
                      segmentState={this.props.segmentState}
                      pricesItem={this.props.pricesItem}
                      idPrice={this.props.idPrice}
                      tokenClient={this.tokenClient}
                      ages={this.state.ages.some(age => age <= 5)}
                    />
                  </Grid>
                </Hidden>

                <Grid item md={9}>
                  <SegmentsFilter
                    filterText={this.state?.filterText}
                    onFilterTextChange={this.handleFilterTextChange}
                    directOnly={this.state.directOnly}
                    onDirectOnlyChange={this.handleDirectOnlyChange}
                    resetDirectOnly={this.resetDirectOnly}
                  />
                  <ContainerSegment
                    segments={this.props.results.segments}
                    filterText={this.state?.filterText}
                  />
                </Grid>
                <Hidden smDown>
                  <Grid item md={3}>
                    <DetailRate
                      x_correlation_id={this.props.results.x_correlation_id}
                      itemsCart={this.props.itemsCart}
                      totalPrice={this.props.totalPrice}
                      segmentState={this.props.segmentState}
                      pricesItem={this.props.pricesItem}
                      idPrice={this.props.idPrice}
                      tokenClient={this.tokenClient}
                      ages={this.state.ages.some(age => age <= 5)}
                    />
                  </Grid>
                </Hidden>
              </Grid>
            </Container>
          </div>
        </main>
      );
    };

    return (
      <Theme>
        <div
          className={`wrapper results wrapper-${config.client.name} ${preloadResult ? "has-preload" : ""}`}
          
          styles={config.styles}
        >
          <Header
            isLogin={config.credential.isLogin}
            client={config.client}
            header={config.header}
            misReservas={config.misReservas}
          />

          {preloadResult !== null ? (
            <Preload />
          ) : this.props.results === undefined ? (
            <Redirect
              to={{
                pathname: `/${this.tokenClient}/trenes/`,
                state: { stateError: true },
              }}
              exact
            />
          ) : Object.keys(this.props.results).length > 0 ? (
            <Fragment>
              <SearchContainer />
              <MainContent />
            </Fragment>
          ) : (
            <Redirect to={{ pathname: `/${this.tokenClient}/trenes/` }} exact />
          )}
          <Footer data={config.footer} client={config.client} />
        </div>
      </Theme>
    );
  }
}

const mapStateToProps = (reducers) => {
  return reducers.searchReducer;
};

const mapDispatchToProps = (dispatch) => {
  return {
    dispatchAddAction: (
      itemsCart,
      totalPrice,
      idPrice,
      pricesItem,
      segmentState
    ) => {
      dispatch(
        addAction(itemsCart, totalPrice, idPrice, pricesItem, segmentState)
      );
    },
    dispatchGetSearch: (
      origin,
      destination,
      departure,
      time,
      ages,
      tramos,
      tokenClient,
      apiToken,
      directOnly
    ) => {
      dispatch(
        getSearchAction(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          tokenClient,
          apiToken,
          directOnly
        )
      );
    },
    dispatchSaveFirstSearchData: (
      origin,
      destination,
      departure,
      time,
      ages,
      tramos,
      tokenClient,
      apiToken,
      directOnly
    ) => {
      dispatch(
        saveFirstSearchData(
          origin,
          destination,
          departure,
          time,
          ages,
          tramos,
          tokenClient,
          apiToken,
          directOnly
        )
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ResultPage);
